export const apikey = 'eb171cadeba7c75bcd55f065c3d69b36.ed76514655a237c9e894c8af27249f2cf50dcf624328cec77214140b52a82ee9'

export const API_URL = 'https://api.dycar.com.ar/api'
// export const API_URL = 'http://localhost:5432/api'
